// @ts-nocheck
import GenericMobileRenderWrestlerWhenNumberInSide from '../GenericUtilitiesComponents/GenericMobileRenderWrestlerWhenNumberInSide';

function MobileRenderWrestlerWhenThreeInSide({ wrestler, side }) {
    return (
        <GenericMobileRenderWrestlerWhenNumberInSide
         wrestler={wrestler}
         side={side}
         heightCardPercentage='33.33%'
         heightPixelAvatar='25px'
         widthPixelAvatar='25px'
         fontSize='6px'
        />
    )
}

export default MobileRenderWrestlerWhenThreeInSide;